import React from "react";
import { Button } from "devextreme-react";
import "./CustomButton.scss";

export default function CustomButton({ text, onClick,icon, stylingMode = "contained", className = "" ,disabled}) {
  return (
    <Button
      text={text}
      stylingMode={stylingMode}
      onClick={onClick}
      icon={icon}
      className={`customButton ${className}`}
      disabled={disabled}
    />
  );
}
